<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
					<!--					<el-form-item label="关键字:">-->
					<!--						<el-input v-model="filters.keyWord" @input="(e) => (filters.keyWord = utils.validForbid(e))" placeholder="项目编号/项目名称" clearable></el-input>-->
					<!--					</el-form-item>-->
					<el-form-item label="省份:">
						<el-select v-model="filters.provinceCode" @change="changeSearchProvince" filterable clearable>
							<el-option v-for="item in provinceSearchOptions" :key="item.id" :label="item.name"
							           :value="item.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="城市:">
						<el-select v-model="filters.cityCode"  filterable clearable>
							<el-option v-for="item in citySearchOptions" :key="item.id" :label="item.name"
							           :value="item.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报告出具开始时间：">
						<el-date-picker
								v-model="filters.startData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="报告出具结束时间：">
						<el-date-picker
								v-model="filters.endData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="统计类型:">
						<el-select v-model="filters.searchType"  filterable clearable>
							<el-option v-for="item in searchTypeArr" :key="item.value" :label="item.name"
							           :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 列表 -->
		<el-table
				:data="tableData"
				border
				id="exportTab"
				style="width: 100%"
				v-loading="listLoading"
				ref="multipleTable"
				@current-change='currentChange'
				:highlight-current-row='true'
		>
			<el-table-column type='index' label="序号" width='80' align="center" :index='indexMethod'></el-table-column>
			<el-table-column prop="provinceName" label="省" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="cityName"  label="市" align="center" width="" show-overflow-tooltip>
				<template v-slot="scope">
					{{scope.row.cityName}}({{scope.row.cityAccountNum}})
				</template>
			</el-table-column>
			<el-table-column prop="areaName" v-if="this.quDialog" label="地区名称" align="center" width="" show-overflow-tooltip>
				<template v-slot="scope">
					{{scope.row.areaName}}({{scope.row.areaAccountNum}})
				</template>
			</el-table-column>
			<el-table-column prop="registerNum" label="登记中项目" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="projectNum" label="已审查项目(规则1/规则2/规则3)" align="center" width="" show-overflow-tooltip min-width="200">
				<template v-slot="scope">
					{{scope.row.projectNum}}({{scope.row.ruleOneProjectNum}}/{{scope.row.ruleTowProjectNum}}/{{scope.row.ruleThreeProjectNum}})

				</template>
			</el-table-column>
			<el-table-column prop="opinionNum" label="初审意见总数" align="center" width="" show-overflow-tooltip></el-table-column>
<!--			<el-table-column prop="forceNum" label="强条总数" align="center" width="" show-overflow-tooltip></el-table-column>-->
			<el-table-column prop="importantNum" label="重要事项总数" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="unimportantNum" label="其他事项总数" align="center" width="" show-overflow-tooltip></el-table-column>
			<!-- <el-table-column prop="ruleOneProjectNum" label="规则1-项目数" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="ruleTowProjectNum" label="规则2-项目数" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="ruleThreeProjectNum" label="规则3-项目数" align="center" width="" show-overflow-tooltip></el-table-column>
			 -->
			
		
		</el-table>
		<!--底部工具条-->
<!--		<el-col :span="24" class="pageBar">-->
<!--			<el-pagination-->
<!--					@size-change="handleSizeChange"-->
<!--					@current-change="handleCurrentChange"-->
<!--					:current-page="pages.pageIndex"-->
<!--					:page-sizes="pages.pageArr"-->
<!--					:page-size="pages.pageSize"-->
<!--					layout="total, sizes, prev, pager, next, jumper"-->
<!--					:total="pages.dataCount">-->
<!--			</el-pagination>-->
<!--		</el-col>-->
<!--		<el-dialog-->
<!--				title=""-->
<!--				:visible.sync="dialogDetailVisible"-->
<!--				v-model="dialogDetailVisible"-->
<!--				:close-on-click-modal="false"-->
<!--				:destroy-on-close="true"-->
<!--				width='50%'-->
<!--		>-->
<!--		-->
<!--		</el-dialog>-->
	
	</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
	getAreaDictionaryByCode, getAreaDictionaryList, getByNamespace,
	getStatisticsFirstOpinionList,
	getStatisticsKYJCOpininDetail,
	
} from '@/api/api'
import * as XLSX from "xlsx";
import FileSaver from 'file-saver'

export default {
	components:{Toolbar},
	data() {
		return {
			citySearchOptions:[],
			provinceSearchOptions:[],
			dialogDetailVisible:false,
			utils: '',
			buttonList: [],
			needData: [],
			filters: {
				startData:undefined,
				endData:undefined,
				provinceCode:undefined,
				cityCode:undefined,
				searchType:0
			},
			quDialog:true,
			// shiDialog:true,
			searchTypeArr:[
				{
					name:'地区统计',
					value:0,
				},
				{
					name:'市统计',
					value:1,
				}
			],
			tableData: [],
			areaArr: [],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [20, 50, 100, 300],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			isExporting:false,
		}
	},
	methods: {
		async init() {
			//   获取所有省份 获取特长
			const initResult = await Promise.all([
				// getByNamespace({ namespace: 'CommonService.OrgPermission.ExpertIdentity' }),
				getAreaDictionaryList({ parentId: 1 }),
				getByNamespace({ namespace: 'CommonService.OrgPermission.ExpertExpertise' }),
			])
			const [provinceRes, expertiseRes] = initResult;
			
			if (provinceRes.data.success) {
				this.provinceSearchOptions = provinceRes.data.response.reverse();
			}
			
		},
		// 省切换
		changeSearchProvince(code) {
			this.filters.cityCode = undefined;
			this.filters.regionCode = undefined;
			this.citySearchOptions = [];
			this.regionSearchOptions = [];
			getAreaDictionaryByCode({ code: code,isEnable : true  }).then(res => {
				var result = res.data
				if (result.success) {
					var id = result.response.id;
					getAreaDictionaryList({ parentId: id }).then(res => {
						if (res.data.success) {
							this.citySearchOptions = res.data.response.reverse();
						}
					})
				}
			})
		},
		//导出
		async exportListData() {
			if (this.isExporting) {
				this.$message.warning('正在导出，请稍后...');
				return;
			} // 如果正在导出，直接返回
			this.isExporting = true; // 标记为正在导出
			
			// this.pages.pageIndex = 1;
			// this.pages.pageSize = 10000;
			// await this.getDataList();
			
			
			let wb = XLSX.utils.book_new();
			// 导出主表格
			let mainTable = document.querySelector('#exportTab');
			let xlsxParam = { raw: true };
			let mainSheet = XLSX.utils.table_to_sheet(mainTable, xlsxParam);
			XLSX.utils.book_append_sheet(wb, mainSheet, '统计汇总');
			// 将工作簿导出为Excel文件
			let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
			try {
				// 使用 FileSaver.saveAs 的成功回调
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '统计汇总.xlsx')
				
				// 导出成功后重新请求列表接口
				// this.pages.pageIndex = 1;
				// this.pages.pageSize = 20;
				// await this.getDataList();
				this.isExporting = false; // 标记为正在导出
			} catch (e) {
				console.error('导出失败:', e);
				this.isExporting = false; // 捕获异常时重置状态
			}
			return wbout;
		},
		
		rowClass () {
			return 'padding:8px!important;'
		},
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		// 列表查询接口
		async getDataList(){
			// console.log(this.filters.timeData,'timeData')
			let params = {
				// pageIndex: this.pages.pageIndex,
				// pageSize: this.pages.pageSize,
				startData:this.filters.startData,
				endData:this.filters.endData,
				provinceCode:this.filters.provinceCode,
				cityCode:this.filters.cityCode,
				searchType:this.filters.searchType
			}
			this.listLoading = true
			const res = await getStatisticsFirstOpinionList(params)
			const result = res.data;
			if(result.success) {
				let dataList = result.response || [];
				
				// 计算合计
				let total = {
					provinceName: '合计',
					cityName: '-',
					areaName: '-',
					registerNum: dataList.reduce((sum, item) => sum + (item.registerNum || 0), 0),
					projectNum: dataList.reduce((sum, item) => sum + (item.projectNum || 0), 0),
					opinionNum: dataList.reduce((sum, item) => sum + (item.opinionNum || 0), 0),
					forceNum: dataList.reduce((sum, item) => sum + (item.forceNum || 0), 0),
					importantNum: dataList.reduce((sum, item) => sum + (item.importantNum || 0), 0),
					unimportantNum: dataList.reduce((sum, item) => sum + (item.unimportantNum || 0), 0)
					
				};
				
				// 将原始数据与合计行合并
				this.tableData = [...dataList, total];
			
			}
			this.listLoading = false
			
		},
		
		// 查询
		getListData() {
			this.pages.pageIndex = 1;
			this.pages.pageSize = 20;
			this.quDialog = this.filters.searchType !== 1
			// this.shiDialog = this.filters.searchType !== 0

			this.getDataList();
		},
		
		// 点击table某一行
		currentChange(val) {
			this.needData = val
			console.log(val,'val')
			
		},
		// 分页
		handleCurrentChange(val) {
			// console.log(val,'分页')
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row || row == ""
					? ""
					: util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm");
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
	},
	watch: {
	
	},
	created(){
		// const currentDate = new Date();
		// const year = currentDate.getFullYear();
		// const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
		// const day = String(currentDate.getDate()).padStart(2, '0');
		//
		// const formattedDate = `${year}-${month}-${day}`;
		// this.filters.startData = formattedDate
		// this.filters.endData = formattedDate
		this.init();
		// console.log(formattedDate,'formattedDate')
		this.utils = util
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getListData();
	}
}
</script>

<style lang="stylus" scoped>
.projectName {
	text-align: center;
}
.projectSelect {
	margin-bottom: 15px;
}
.projectTitle {
	margin-bottom: 15px
}
.replyBtn {
	margin: 10px 0;
	color: #409eff;
	cursor: pointer;
	width: 30px;
}
.replyMessage {
	background: #eee;
	line-height: 30px;
	padding: 5px;
	border-radius: 2px;
	margin: 5px 15px;
}
.titleTimer {
	margin-left: 10px;
}
.green_t {
	color: green;
}
.red_t {
	color: red;
}
</style>
